import React, { useReducer } from "react"

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialPage = {
  page: "home",
}

function reducer(state, action) {
  // console.log("action: " + action.page);
  switch (action.type) {
    case "CURRENT_PAGE": {
      return {
        ...state,
        page: action.page,
      }
    }
    default:
      state
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialPage)
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider